(function(){
  var listenerAlreadyAdded = false;
  const toRad = d => d * Math.PI / 180;
  function haversine(a, b, unit){
    const R = unit === 'mi' ? 3958.8 : 6371;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const lat1 = toRad(a.lat);
    const lat2 = toRad(b.lat);
    const h = Math.sin(dLat/2)**2 + Math.cos(lat1)*Math.cos(lat2)*Math.sin(dLng/2)**2;
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  const cacheKey = 'storeLocatorGeocodeCache';
  let geoCache = {};
  try{geoCache = JSON.parse(localStorage.getItem(cacheKey))||{};}catch(e){geoCache={};}
  function getCachedGeo(query){return geoCache[query.toLowerCase()];}
  function setCachedGeo(query, value){
    geoCache[query.toLowerCase()] = value;
    try{localStorage.setItem(cacheKey, JSON.stringify(geoCache));}catch(e){}
  }
  function fetchAllStockists(url, page = 1, acc = []){
    return fetch(`${url}?page=${page}`).then(r=>r.json()).then(data=>{
      acc = acc.concat(data.stockists || []);
      if(data.has_next_page){
        return fetchAllStockists(url, page+1, acc);
      }
      return acc;
    });
  }
  function initSection(root){
    const stockistData = document.getElementById('StockistsJSON');
    console.log("stockistData: ", stockistData)
    if(!stockistData) return;
    var stockists = JSON.parse(stockistData.textContent);
    console.log("initSection stockists: ", stockists)
    const listEl = root.querySelector('#StoreList');
    const mapEl = root.querySelector('#StoreMap');
    const searchForm = root.querySelector('#StoreSearch');
    const searchInput = root.querySelector('#StoreSearchInput');
    const clearBtn = root.querySelector('#StoreSearchClear');
    const locateBtn = root.querySelector('#StoreLocate');
    const searchMessage = root.querySelector('#StoreSearchMessage');
    const searchToggle = root.querySelector('#StoreSearchToggle');
    const emptyEl = root.querySelector('#StoreEmpty');
    const noResultsPanel = root.querySelector('#StoreNoResultsPanel');
    const announce = root.querySelector('#StoreAnnounce');
    const clusterColor = root.dataset.clusterColor || '#000';
    const settings = {
      radius: parseFloat(root.dataset.radius),
      units: root.dataset.units,
      showAll: root.dataset.showAll === 'true',
      noResults: root.dataset.noResults,
      showDistance: root.dataset.showDistance === 'true',
      showTelephone: root.dataset.showTelephone === 'true'
    };
    const loadAll = root.dataset.loadAllStores === 'true';
    const stockistsUrl = root.dataset.stockistsUrl || '/stockists.json';
    let map, markers = [], infoWindow, clusterer;
    let currentItems = [];
    let markerIcon;
    let searchPerformed = false;
    if(root.dataset.pin){
      markerIcon = { url: root.dataset.pin };
      const img = new Image();
      img.onload = () => {
        const ratio = img.height / img.width;
        markerIcon.scaledSize = new google.maps.Size(50, 50 * ratio);
        markers.forEach(m => m.setIcon(markerIcon));
      };
      img.src = root.dataset.pin;
    }
    if(noResultsPanel){
      noResultsPanel.querySelectorAll('.sl-no-results-btn').forEach(btn=>{
        //btn.removeEventListener('click');
        btn.addEventListener('click',()=>{
          document.dispatchEvent(new CustomEvent('storeLocatorNoResultsCtaClick',{detail:{cta:btn.dataset.cta}}));
        });
      });
    }

    function renderList(items){
      listEl.innerHTML = '';
      // Limit the number of items shown in the sidebar to avoid rendering
      // thousands of elements which can impact performance. All markers are
      // still rendered on the map.
      const listItems = items.slice(0, 50);
      if(items.length === 0){
        if(noResultsPanel) noResultsPanel.hidden = true;
        if(!searchPerformed){
          emptyEl.hidden = true;
          announce.textContent = '';
          return;
        }
        announce.textContent = settings.noResults;
        if(noResultsPanel){
          noResultsPanel.hidden = false;
          emptyEl.hidden = true;
        } else {
          emptyEl.hidden = false;
        }
        return;
      }
      emptyEl.hidden = true;
      if(noResultsPanel) noResultsPanel.hidden = true;
      announce.textContent = `${items.length} result${items.length>1?'s':''}`;
      listItems.forEach((item, idx)=>{
        const card = document.createElement('div');
        card.className = 'sl-item';
        card.setAttribute('role','listitem');
        card.tabIndex = 0;
        const addr = [item.address1,item.address2,item.city,item.state,item.postcode,item.country].filter(Boolean).join(', ');
        card.innerHTML = `
          <div class="sl-item-name">${item.name}</div>
          <div class="sl-item-address">${addr}</div>
          ${settings.showTelephone && item.telephone ? `<div class="sl-item-tel"><a href="tel:${item.telephone}">${item.telephone}</a></div>` : ''}
          ${settings.showDistance && item.distance!=null ? `<div class="sl-item-distance">${item.distance.toFixed(1)} ${settings.units}</div>` : ''}`;
        card.addEventListener('click',()=>{
          google.maps.event.trigger(markers[idx], 'click');
        });
        card.addEventListener('keyup',e=>{if(e.key==='Enter') card.click();});
        listEl.appendChild(card);
      });
    }
    function renderMarkers(items){
      if(clusterer){clusterer.clearMarkers();}
      markers.forEach(m=>m.setMap(null));
      markers=[];
      items.forEach((item, idx)=>{
        if(item.latitude == null || item.longitude == null) return;
        const marker = new google.maps.Marker({
          position:{lat:item.latitude,lng:item.longitude},
          map: map,
          title: item.name,
          icon: markerIcon
        });
        marker.addListener('click',()=>{
          if(!infoWindow) infoWindow = new google.maps.InfoWindow();
          const addr = [item.address1,item.address2,item.city,item.state,item.postcode,item.country].filter(Boolean).join(', ');
          const tel = settings.showTelephone && item.telephone ? `<br><a href="tel:${item.telephone}">${item.telephone}</a>` : '';
          const dir = `<br><a target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=${item.latitude},${item.longitude}">Get directions</a>`;
          infoWindow.setContent(`<strong>${item.name}</strong><br>${addr}${tel}${dir}`);
          infoWindow.open(map, marker);
          const pos = marker.getPosition();
          map.panTo(pos);
          map.setZoom(14);
          const cards = listEl.querySelectorAll('.sl-item');
          cards.forEach(c=>c.classList.remove('active'));
          const card = cards[idx];
          if(card){card.classList.add('active');card.scrollIntoView({behavior:'smooth',block:'center'});}
        });
        markers.push(marker);
      });
      if(root.dataset.clustering === 'true' && window.markerClusterer && markers.length > 2){
        clusterer = new markerClusterer.MarkerClusterer({
          map,
          markers,
          gridSize: parseInt(root.dataset.clusterSize),
          renderer: {
            render({count, position}){
              return new google.maps.Marker({
                position,
                label: {text:String(count), color:'#fff'},
                icon: {
                  path: google.maps.SymbolPath.CIRCLE,
                  fillColor: clusterColor,
                  fillOpacity: 0.7,
                  strokeColor: clusterColor,
                  strokeWeight: 1,
                  scale: 30
                }
              });
            }
          }
        });
      }

      //root.classList.remove('sl-loading');
    }
    function fitToMarkers(){
      const bounds = new google.maps.LatLngBounds();
      markers.forEach(m=>bounds.extend(m.getPosition()));
      if(!bounds.isEmpty()) {
        map.fitBounds(bounds);
        const maxZoom = parseInt(root.dataset.searchZoom);
        if(maxZoom){
          google.maps.event.addListenerOnce(map, 'idle', ()=>{
            if(map.getZoom() > maxZoom) map.setZoom(maxZoom);
          });
        }
      }
    }
    function updateVisibleFromMap(){
      console.log("updateVisibleFromMap")
      if(!map) return;
      const bounds = map.getBounds();
      if(!bounds) return;
      const visible = currentItems.filter(it=>{
        if(it.latitude == null || it.longitude == null) return false;
        return bounds.contains(new google.maps.LatLng(it.latitude, it.longitude));
      });
      console.log("visible: ", visible)
      renderList(visible);
      renderMarkers(visible);
    }
    function applySearch(coords, overrideItems){
      console.log("applySearch stockists: ", stockists)
      let items = overrideItems ? overrideItems.map(s=>Object.assign({}, s)) : stockists.filter(s=>s.latitude!=null && s.longitude!=null).map(s=>Object.assign({}, s));
      if(coords){
        console.log("items 1: ", items)
        items.forEach(it=>{
          it.distance = haversine(coords, {lat:it.latitude,lng:it.longitude}, settings.units==='mi'?'mi':'km');
        });
        console.log("items 3: ", items)
        items = items.filter(it => it.distance <= settings.radius).sort((a,b)=>a.distance-b.distance);
        console.log("items 3: ", items)
        console.log("items.length: ", items.length)
      } else if(!overrideItems){
        if(settings.showAll){
          items.sort((a,b)=>a.name.localeCompare(b.name));
        } else {
          items = [];
        }
      }



      renderList(items);
      // If a search was performed but returned no matches, still show all
      // stockists on the map so the user sees available locations.
      let markerItems = items;
      if(items.length === 0 && searchPerformed){
        markerItems = stockists.filter(s=>s.latitude!=null && s.longitude!=null);
      }
      renderMarkers(markerItems);
      currentItems = markerItems;
      if((coords || overrideItems || markerItems.length === stockists.length) && markers.length){fitToMarkers();}

      //debugger;
    }
    function initMap(){
      console.log('START initing map...');
      const options = {
        center:{lat:parseFloat(root.dataset.defaultLat), lng:parseFloat(root.dataset.defaultLng)},
        zoom: parseInt(root.dataset.defaultZoom)
      };
      if(root.dataset.mapStyles){
        try{options.styles = JSON.parse(root.dataset.mapStyles);}catch(e){}
      }
      map = new google.maps.Map(mapEl, options);
      // Expose the map instance so external scripts can access it.
      // This allows global helpers like updateMapWithAllStores to
      // retrieve the existing map and add markers to it.
      mapEl.mapInstance = map;
      window.storeLocatorMap = map;
      if(navigator.geolocation){
        requestLocation(false);
      } else {
        applySearch(null);
        map.addListener('zoom_changed', updateVisibleFromMap);
        map.addListener('dragend', updateVisibleFromMap);
        console.log('END initing map...');
        root.classList.remove('sl-loading');
      }
    }

    function geocodeCityOSM(query) {
      return fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`)
        .then(r => r.json())
        .then(results => {
          if (results && results[0]) {
            return {
              lat: parseFloat(results[0].lat),
              lng: parseFloat(results[0].lon)
            };
          }
          return null;
        })
        .catch(() => null);
    }

    function requestLocation(userTriggered){
      if(userTriggered) {
        root.classList.add('sl-loading');
        //if(locateBtn) locateBtn.disabled = true;
      }
      navigator.geolocation.getCurrentPosition(pos=>{
        // Mark search as performed when a location is successfully obtained.
        // This ensures the no-results message is shown even if the initial
        // geolocation request was not directly triggered by the user.
        /*
        if(userTriggered) {
          root.classList.add('sl-loading');
        }
        */

        searchPerformed = true;
        applySearch({lat:pos.coords.latitude,lng:pos.coords.longitude});
        if(searchMessage){
          searchForm.hidden = true;
          searchMessage.hidden = false;
        }
        
        root.classList.remove('sl-loading');
        //if(locateBtn) locateBtn.disabled = false;
      }, () => {
        root.classList.remove('sl-loading');
        //if(locateBtn) locateBtn.disabled = false;
      });
    }

    function submitSearchForm(e) {
      e.preventDefault();
      searchPerformed = true;
      const q = searchInput.value.trim();
      console.log("q: ", q)
      if(q){
        const qLower = q.toLowerCase();
        const matches = stockists.filter(s=>{
          return [s.country, s.city, s.state, s.postcode, s.name, s.address1, s.address2].some(f=>f && f.toLowerCase().includes(qLower));
        });
        console.log("matches.length: ", matches.length)
        if(matches.length){
          applySearch(null, matches);
        } else {
         geocodeCityOSM(q).then(loc => {
           if(loc){
            console.log("loc: ", loc)
            applySearch(loc);
          } else {
            applySearch(null);
            if(noResultsPanel) noResultsPanel.hidden = true;
            emptyEl.textContent = 'We couldn’t find that location';
            emptyEl.hidden = false;
            announce.textContent = 'We couldn’t find that location';
          }
        });
        }
      } else {
        applySearch(null);
      }
    }

    if(!listenerAlreadyAdded) {
      //searchForm.removeEventListener('submit', submitSearchForm);
      searchForm.addEventListener('submit',submitSearchForm);
      listenerAlreadyAdded = true;
    }
    //clearBtn.removeEventListener('click');
    clearBtn.addEventListener('click',()=>{searchInput.value='';searchPerformed=false;applySearch(null);});
    if(searchToggle){
      //searchToggle.removeEventListener('click');
      searchToggle.addEventListener('click',()=>{
        if(searchMessage) searchMessage.hidden = true;
        searchForm.hidden = false;
        searchInput.focus();
      });
    }
    if(locateBtn){
      if(navigator.geolocation){
        //locateBtn.removeEventListener('click');
        locateBtn.addEventListener('click',()=>requestLocation(true));
      } else {
        locateBtn.style.display='none';
      }
    }
    function finishInit(){
      initMap();
    }
    /*
    if(loadAll){
      fetchAllStockists(stockistsUrl).then(all=>{
        stockists = all;
        ensureCoords().then(finishInit);
      }).catch(()=>{
        ensureCoords().then(finishInit);
      });
    } else {
      ensureCoords().then(finishInit);
    }
    */
    //ensureCoords().then(finishInit);
    finishInit();
  }
  const TOKEN = '505eba8215fc5bc6d09ccfa29c3a82b1';//"{{ section.settings.storefront_token | escape }}";
  if (!TOKEN) { console.warn("[Stockists] Missing Storefront token"); return; }

  const QUERY = `
    query Stockists($first:Int!, $after:String) {
      metaobjects(type: "stockists", first: $first, after: $after) {
        nodes {
          id
          handle
          fields { key value }
        }
        pageInfo { hasNextPage endCursor }
      }
    }
  `;

  async function fetchPage(after=null) {
    const res = await fetch("/api/2025-07/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": TOKEN
      },
      body: JSON.stringify({ query: QUERY, variables: { first: 250, after } })
    });
    const json = await res.json();
    if (json.errors || !json.data?.metaobjects) {
      console.error("[Stockists] Storefront errors:", json.errors, json.data);
      throw new Error("Storefront API error");
    }
    return json.data.metaobjects;
  }

  function mapNode(n) {
    const f = Object.fromEntries(n.fields.map(x => [x.key, x.value]));
    return {
      id: n.id,
      handle: n.handle,
      name: f.name_of_stockist || n.handle,
      address1: f.first_line_of_address || "",
      address2: f.second_line_of_address || "",
      city: f.city || "",
      state: f.state || "",
      postcode: f.postcode_zip || "",
      country: f.country || "",
      latitude: parseFloat(f.latitude) || null,
      longitude: parseFloat(f.longitude) || null
    };
  }

  async function updateStockistsView(stockists) {
    const emptyEl    = document.getElementById("StoreEmpty");
    const announceEl = document.getElementById("StoreAnnounce");
    const jsonEl     = document.getElementById("StockistsJSON");

    if (jsonEl) jsonEl.textContent = JSON.stringify(stockists || []);
    if (emptyEl)    emptyEl.hidden = !!(stockists && stockists.length);
    if (announceEl) announceEl.textContent = `${(stockists && stockists.length) || 0} locations loaded`;
  }

  async function initAll(){
    const all = [];
    let after = null;
    do {
      const conn = await fetchPage(after);
      all.push(...(conn.nodes || []).map(mapNode));
      after = conn.pageInfo.hasNextPage ? conn.pageInfo.endCursor : null;
    } while (after);

    // hydrate the JSON blob your existing code reads
    const holder = document.getElementById("StockistsJSON");
    holder.textContent = JSON.stringify(all);

    console.log('SUCCESS');
    window.all_stockists = all;
    await updateStockistsView(window.all_stockists);
    

    document.querySelectorAll('[data-store-locator]').forEach((el, i) => initSection(el));
  }
  if(window.google && window.google.maps){
    initAll();
  }
  window.initStoreLocator = initAll;
})();

// Global function to update map with all stores
window.updateMapWithAllStores = function(allStores) {
  const storeLocator = document.querySelector('[data-load-all-stores="true"]');
  if (!storeLocator) return;
  
  const mapElement = storeLocator.querySelector('#StoreMap');
  if (!mapElement || !window.google || !window.google.maps) return;
  
  // Get the existing map instance
  const mapInstance = mapElement.mapInstance || window.storeLocatorMap;
  if (!mapInstance) return;
  
  // Clear existing markers
  if (window.storeMarkers) {
    window.storeMarkers.forEach(marker => marker.setMap(null));
  }
  window.storeMarkers = [];
  
  // Get pin image from data attribute
  const pinImage = storeLocator.dataset.pin;
  
  // Create markers for all stores
  allStores.forEach(store => {
    if (store.latitude && store.longitude && !isNaN(store.latitude) && !isNaN(store.longitude)) {
      const marker = new google.maps.Marker({
        position: {
          lat: parseFloat(store.latitude),
          lng: parseFloat(store.longitude)
        },
        map: mapInstance,
        title: store.name,
        icon: pinImage || undefined
      });
      
      // Create info window for each marker
      const infoWindow = new google.maps.InfoWindow({
        content: `
          <div class="store-info">
            <h3>${store.name}</h3>
            <p>${store.address1}${store.address2 ? ', ' + store.address2 : ''}</p>
            <p>${store.state} ${store.postcode}</p>
            <p>${store.country}</p>
            ${store.telephone ? `<p>Tel: ${store.telephone}</p>` : ''}
          </div>
        `
      });
      
      //marker.removeListener('click');
      marker.addListener('click', () => {
        // Close any open info windows
        if (window.currentInfoWindow) {
          window.currentInfoWindow.close();
        }
        infoWindow.open(mapInstance, marker);
        window.currentInfoWindow = infoWindow;
      });
      
      window.storeMarkers.push(marker);
    }
  });
  
  // Update clustering if enabled
  const enableClustering = storeLocator.dataset.clustering === 'true';
  if (enableClustering && window.MarkerClusterer) {
    if (window.markerCluster) {
      window.markerCluster.clearMarkers();
    }
    
    const clusterOptions = {
      gridSize: parseInt(storeLocator.dataset.clusterSize) || 60,
      maxZoom: 15
    };
    
    window.markerCluster = new MarkerClusterer(mapInstance, window.storeMarkers, clusterOptions);
  }
  
  console.log(`Map updated with ${allStores.length} stores`);
};

// Initialize store markers array
window.storeMarkers = [];
